import { TableSelectionDialogComponent } from './table-selection-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonLayoutModule, CommonUIModule, CommonTranslationModule } from '@sdbn/common';

import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TMCTableModule } from '@sdbn/appclient';



@NgModule({
  declarations: [TableSelectionDialogComponent],
  exports: [TableSelectionDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    TMCTableModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule
  ]
})
export class TableSelectionDialogModule { }
